// src/components/address_block_title.js
import React from 'react';
import {useTranslation} from "react-i18next";

const AddressBlockTitle = () => {
    const {t} = useTranslation();
    return (
        <div className="address_block_title">
            <p className="address_block_title_text bold">{t("address_block_title_text")}</p>
        </div>
    );
};

export default AddressBlockTitle;
